import Client from "../client/ApiClient"
const resource = "/api/v1/surveillance"

const getDictionary = () => Client.get(`${resource}/dictionary/`)
/** Metrics vận hành (manage_ward / superuser): số ca, audit 24h. */
const getMetrics = () => Client.get(`${resource}/metrics/`)

const getWards = (params) => Client.get(`${resource}/wards/`, { params })
const createWard = (data) => Client.post(`${resource}/wards/`, data)
const updateWard = (id, data) => Client.put(`${resource}/wards/${id}/`, data)
const deleteWard = (id) => Client.delete(`${resource}/wards/${id}/`)

const getCases = (params) => Client.get(`${resource}/cases/`, { params })
const getCase = (id) => Client.get(`${resource}/cases/${id}/`)
const setCaseProposalListMode = (id, data) => Client.patch(`${resource}/cases/${id}/proposal-list-mode/`, data)
const getCaseAuditLogs = (id, params) => Client.get(`${resource}/cases/${id}/audit-logs/`, { params })
const getAuditLogs = (params) => Client.get(`${resource}/audit-logs/`, { params })
const getAuditLogsExportCsv = (params) => Client.get(`${resource}/audit-logs/export-csv/`, { params, responseType: "blob" })
const createCase = (data) => Client.post(`${resource}/cases/`, data)
const updateCase = (id, data) => Client.patch(`${resource}/cases/${id}/`, data)

const getBaseline = (caseId) => Client.get(`${resource}/cases/${caseId}/baseline/`)
const createBaseline = (caseId, data) => Client.post(`${resource}/cases/${caseId}/baseline/`, data)
const updateBaseline = (caseId, baselineId, data) => Client.put(`${resource}/cases/${caseId}/baseline/${baselineId}/`, data)

const getFollowups = (caseId) => Client.get(`${resource}/cases/${caseId}/followups/`)
const createFollowup = (caseId, data) => Client.post(`${resource}/cases/${caseId}/followups/`, data)
const updateFollowup = (caseId, milestone, data) => Client.patch(`${resource}/cases/${caseId}/followups/${milestone}/`, data)

const getAttachments = (caseId) => Client.get(`${resource}/cases/${caseId}/attachments/`)
const uploadAttachment = (caseId, formData) => Client.post(`${resource}/cases/${caseId}/attachments/`, formData, {
  headers: { "Content-Type": "multipart/form-data" }
})

const getDiagnosis = (caseId) => Client.get(`${resource}/cases/${caseId}/diagnosis/`)
const createDiagnosis = (caseId, data) => Client.post(`${resource}/cases/${caseId}/diagnosis/`, data)
const updateDiagnosis = (caseId, diagnosisId, data) => Client.put(`${resource}/cases/${caseId}/diagnosis/${diagnosisId}/`, data)

const getPreventionBundle = (caseId) => Client.get(`${resource}/cases/${caseId}/prevention-bundle/`)
const createPreventionBundle = (caseId, data) => Client.post(`${resource}/cases/${caseId}/prevention-bundle/`, data)
const updatePreventionBundle = (caseId, bundleId, data) => Client.put(`${resource}/cases/${caseId}/prevention-bundle/${bundleId}/`, data)

const getDashboardStats = () => Client.get(`${resource}/dashboard/stats/`)
const getExecutiveDashboard = (params) => Client.get(`${resource}/analytics/dashboard/executive/`, { params })

const getSurgeryTypes = (params) => Client.get(`${resource}/surgery-types/`, { params })
const createSurgeryType = (data) => Client.post(`${resource}/surgery-types/`, data)
const updateSurgeryType = (id, data) => Client.put(`${resource}/surgery-types/${id}/`, data)
const deleteSurgeryType = (id) => Client.delete(`${resource}/surgery-types/${id}/`)

const getAntibiotics = (params) => Client.get(`${resource}/antibiotics/`, { params })
const createAntibiotic = (data) => Client.post(`${resource}/antibiotics/`, data)
const updateAntibiotic = (id, data) => Client.put(`${resource}/antibiotics/${id}/`, data)
const deleteAntibiotic = (id) => Client.delete(`${resource}/antibiotics/${id}/`)

const getRules = (params) => Client.get(`${resource}/rules/`, { params })
const createRule = (data) => Client.post(`${resource}/rules/`, data)
const updateRule = (id, data) => Client.put(`${resource}/rules/${id}/`, data)
const deleteRule = (id) => Client.delete(`${resource}/rules/${id}/`)

const getReport = (params) => Client.get(`${resource}/reports/`, { params })
/** Xuất Excel/CSV từ BE theo filter (date_from, date_to). Trả về blob. */
const getReportExportExcel = (params) => Client.get(`${resource}/reports/export-excel/`, { params, responseType: "blob" })
const getReportExportCsv = (params) => Client.get(`${resource}/reports/export-csv/`, { params, responseType: "blob" })
/** Warehouse-backed: độ đầy đủ dữ liệu theo tháng. */
const getReportCompleteness = (params) => Client.get(`${resource}/reports/completeness/`, { params })
/** Warehouse-backed: cảnh báo chất lượng theo tháng. */
const getReportQualitySignals = (params) => Client.get(`${resource}/reports/quality-signals/`, { params })
/** PDF tóm tắt cho họp (snapshot + watermark trên server). Body: { date_from, date_to } */
const postReportMeetingPack = (data) =>
  Client.post(`${resource}/reports/meeting-pack/`, data, { responseType: "blob" })
/** Danh mục KPI định nghĩa có phiên bản (read-only). */
const getKpiDefinitions = (params) => Client.get(`${resource}/kpi-definitions/`, { params })
/** Mẫu meeting pack (layout section). */
const getMeetingPackTemplates = (params) => Client.get(`${resource}/meeting-pack-templates/`, { params })
/** Preset bộ lọc báo cáo theo user. */
const getReportSavedViews = (params) => Client.get(`${resource}/report-saved-views/`, { params })
const createReportSavedView = (data) => Client.post(`${resource}/report-saved-views/`, data)
const deleteReportSavedView = (id) => Client.delete(`${resource}/report-saved-views/${id}/`)
const getPriorityCases = () => Client.get(`${resource}/dashboard/priority-cases/`)
/** Ca draft/active có dấu hiệu ưu tiên (khoa/loại PT/nguy cơ) — danh sách đề xuất giám sát. */
const getProposedCases = (params) => Client.get(`${resource}/dashboard/proposed-cases/`, { params })
const getQualitySignals = (params) => Client.get(`${resource}/quality-signals/`, { params })

export default {
  getDictionary,
  getMetrics,
  getWards,
  createWard,
  updateWard,
  deleteWard,
  getCases,
  getCase,
  setCaseProposalListMode,
  getCaseAuditLogs,
  getAuditLogs,
  getAuditLogsExportCsv,
  createCase,
  updateCase,
  getBaseline,
  createBaseline,
  updateBaseline,
  getFollowups,
  createFollowup,
  updateFollowup,
  getAttachments,
  uploadAttachment,
  getDiagnosis,
  createDiagnosis,
  updateDiagnosis,
  getPreventionBundle,
  createPreventionBundle,
  updatePreventionBundle,
  getDashboardStats,
  getExecutiveDashboard,
  getSurgeryTypes,
  createSurgeryType,
  updateSurgeryType,
  deleteSurgeryType,
  getAntibiotics,
  createAntibiotic,
  updateAntibiotic,
  deleteAntibiotic,
  getRules,
  createRule,
  updateRule,
  deleteRule,
  getReport,
  getReportExportExcel,
  getReportExportCsv,
  getReportCompleteness,
  getReportQualitySignals,
  postReportMeetingPack,
  getKpiDefinitions,
  getMeetingPackTemplates,
  getReportSavedViews,
  createReportSavedView,
  deleteReportSavedView,
  getPriorityCases,
  getProposedCases,
  getQualitySignals,
}
